<tgx-permissions-by-service-form
  [mainRole]="mainRole"
  [initialPermissions]="initialPermissions"
  [canEditRoles]="canEditTargetRoles"
  [isLoading]="isLoading"
  (permissionsChanged)="handlePermissionsChanged($event)"
  (invalidForm)="handleInvalidForm($event)"
  (billingSelectionInvalid)="handleBillingSelectionInvalid($event)"
  (previousStep)="handlePreviousStep($event)"
></tgx-permissions-by-service-form>
